import { z } from 'zod';
import { legalClientAddressSchema } from './ILegalClientAddress';
import { ILegalClientAssetSchema } from './ILegalClientAsset';
import { contactInformationSchema } from './ILegalClientContactInformation';

export const legalClientSchema = z.object({
  idAcademicTitle: z.number().nullable(),
  idArnoTop: z.number().nullable().optional(),
  idArnoTopIntern: z.number().nullable().optional(),
  idBusinessForm: z.number(),
  idContactGroup: z.number().nullable().optional(),
  idCountry: z.number(),
  idGender: z.number().nullable().optional(),
  idLegalClient: z.number(),
  idLegalClientType: z.number(),
  idLegalRole: z.number().nullable().optional(),
  idLegalClientUser: z
    .number()
    .nullable()
    .transform(x => x ?? -1),
  idRelationshipRole: z.number().nullable().optional(), // TODO: is that necessary?
  AccountingArray: z.array(z.any()),
  FirstName: z.string().nullable(),
  LastName: z.string().nonempty(),
  SurName: z.string().nullable().optional(),
  Email: z.string().nullable(),
  Birthdate: z.string().nullable().optional(),
  Birthplace: z.string().nullable().optional(),
  PlaceOfDeath: z.string().nullable().optional(),
  DateOfDeath: z.string().nullable().optional(),
  Gender: z.string().nullable().optional(),
  TaxNumber: z.string().nullable().optional(),
  SalesTaxNumber: z.string().nullable().optional(),
  AcademicTitle: z.string().nullable().optional(),
  BusinessForm: z.string().nullable().optional(),
  LegalClientType: z.string(),
  loginPossible: z.boolean(),
  passwordResetRequired: z.boolean(),
  last_login_at: z.string().nullable().optional(),
  isReceivingEmailEnabled: z.boolean(),
  Updated_at: z.string().nullable().optional(),
  Created_at: z.string().nullable().optional(),
  syncWithArnoTop: z.boolean(),
  //LegalClientUser: legalClientUserSchema,
  //syncWithArnotop: z.boolean().optional(),
  ContactGroup: z.string().nullable().optional(),
  LastSyncWithArnoTop: z.string().nullable().optional(),
  enableInvoiceReminding: z.boolean().optional(),
  enableCertificateReminding: z.boolean().optional(),

  // !!! Attr. ohne Attr. in der DB
  syncType: z.number().optional(),
  resetPassword: z.boolean().optional(),

  AssetArray: z.array(ILegalClientAssetSchema),

  data: z.object({
    addToLegalTransaction: z.boolean().optional(),
  }),
});

export const legalClientFullObjectSchema = legalClientSchema.extend({
  AddressArray: z.array(legalClientAddressSchema),
  ContactInformationArray: z.array(contactInformationSchema),
});

export type ILegalClient = z.infer<typeof legalClientFullObjectSchema>;
export type ILegalClientFullObject = z.infer<
  typeof legalClientFullObjectSchema
>;

export function getEmptyLegalClient(
  legalClientArray?: ILegalClient[],
  idRelationshipRole?: number,
  addToLegalTransaction?: boolean
): ILegalClient {
  let tmpId = -1;

  if (legalClientArray && legalClientArray.length > 0) {
    const tmpArrayId =
      Math.min(...legalClientArray.map(x => x.idLegalClient)) - 1;
    if (tmpArrayId <= tmpId) {
      tmpId = tmpArrayId;
    }
  }

  return {
    AcademicTitle: 'kein',
    AccountingArray: [],
    AddressArray: [],
    Birthdate: null,
    Birthplace: '',
    BusinessForm: 'Privat',
    ContactGroup: null,
    ContactInformationArray: [],
    Created_at: null,
    DateOfDeath: null,
    Email: null,
    FirstName: '',
    Gender: '',
    LastName: '',
    LastSyncWithArnoTop: null,
    LegalClientType: '',
    PlaceOfDeath: null,
    SalesTaxNumber: null,
    SurName: null,
    TaxNumber: null,
    Updated_at: null,
    idAcademicTitle: 1,
    idArnoTop: null,
    idArnoTopIntern: null,
    idBusinessForm: 1,
    idContactGroup: null,
    idCountry: 1,
    idGender: -1,
    idLegalClient: tmpId, // ids of new legal client should be negative but unique
    idLegalClientType: -1,
    idLegalClientUser: -1,
    idLegalRole: null,
    isReceivingEmailEnabled: false,
    last_login_at: null,
    loginPossible: false,
    passwordResetRequired: false,
    syncWithArnoTop: false,
    // idRelationshipRole: idRelationshipRole,
    AssetArray: [],
    data: {
      addToLegalTransaction: addToLegalTransaction
        ? addToLegalTransaction
        : false,
    },
  };
}
